import React, { useState } from "react";
import { Link } from "react-router-dom";
import { BrowserRouter } from "react-router-dom";
import "../Styles/phoneNav.css";

function PhoneNav() {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  return (
    <div className="phone-nav">
      <BrowserRouter>
        <nav>
          <ul className="phone-NavBar-Links">
            <li className="Pro-NavBar-Links-list1">
              <Link
                to="/"
                className={`phone-nav-link ${
                  currentPath === "/" && "link-glow"
                }`}
                onClick={() => {
                  window.location.href = "/";
                }}
              >
                Workshop
              </Link>
            </li>
            <li className="Pro-NavBar-Links-list1">
              <Link
                to="/shop"
                className={`phone-nav-link ${
                  currentPath === "/shop" && "link-glow"
                }`}
                onClick={() => {
                  window.location.href = "/shop";
                }}
              >
                Shop
              </Link>
            </li>
            <li className="Pro-NavBar-Links-list1">
              <Link
                to="/incubator"
                className={`phone-nav-link ${
                  currentPath === "/incubator" && "link-glow"
                }`}
                onClick={() => {
                  window.location.href = "/incubator";
                }}
              >
                Incubator
              </Link>
            </li>
            <li className="Pro-NavBar-Links-list1">
              <Link
                to="/"
                className={`phone-nav-link ${
                  currentPath === "/unassigned" && "link-glow"
                }`}
              >
                MagicBank
              </Link>
            </li>
            <li className="Pro-NavBar-Links-list1">
              <Link
                to="/"
                className={`phone-nav-link ${
                  currentPath === "/unassigned" && "link-glow"
                }`}
              >
                Redeem
              </Link>
            </li>
          </ul>
        </nav>
      </BrowserRouter>
    </div>
  );
}

export default PhoneNav;
